<div id="modal-exportar-container">
  <svg class="icon-close-msg" [mat-dialog-close]="''">
    <use xlink:href="#icon-close"></use>
  </svg>
  <h1 style="margin-bottom: 5px;">{{data.titulo}}</h1>
    <div class="bloque-informes-excel">
      <div *ngIf="!esTipoContenido()">
        <div class="buscador">
          <app-input-buscador (buscador)="buscarItems($event)" [inputWidth]="'180'" [textoBuscar]="textoBuscar"></app-input-buscador>
        </div>
        <div class="seleccionar-todos">
          <input type="checkbox"
                 [checked]="isTodosSeleccionados()"
                 (change)="toggleSeleccionarTodos($any($event.target).checked)">
          <label>Seleccionar todos</label>
        </div>
        <div class="cabecera-informe-excel">
          <span class="titulo-columna-nombre">Nombre documento</span>
          <span class="titulo-columna-cantidad">Cantidad</span>
        </div>
      </div>
      <div class="lista-informes-excel">
        <div *ngFor="let informe of informesExcel"
             [ngClass]="{
               'item-tipo-contenido': esTipoContenido(),
               'item-informe-excel': !esTipoContenido(),
               'item-informe-excel-seleccionado': !esTipoContenido() && informe.seleccionado
             }">
          <div class="flex-lista-informes">
            <input type="checkbox"
                   [checked]="informe.seleccionado"
                   (change)="onInformeSeleccionChange(informe, $any($event.target).checked)"/>
            <label>
              {{ informe.nombre }}
              <ng-container *ngIf="informe.version != null"> - V.{{ informe.version }}</ng-container>
            </label>
            <span *ngIf="informe.cantidad">{{ informe.cantidad }}</span>
          </div>
        </div>
      </div>
    </div>
    <span class="texto-validacion" *ngIf="errorSeleccion && !getInformesSeleccionados().length">
      Debes seleccionar al menos un tipo de informe
    </span>
  <div class="modal-buttons">
    <app-boton-accion mat-dialog-close class="btn-cancel-modal" [id]="'cancelar'" [outline]="true" [cancelar]="true" [titulo]="'Cancelar'"></app-boton-accion>
    <app-boton-accion (click)="aceptarExportar()" [id]="'Aceptar'" [titulo]="'Aceptar'"></app-boton-accion>
  </div>
</div>
